<template>
    <div class="container" v-title="pageTitle">
        <div>
            <div style="width: 96%;margin-left: 2%;">
                <div class="herad">
                    <div class="flx" style="font-weight: 600;">
                        <div class="sz" style="line-height: 45px;padding-right: 10px;font-size: 24px;">¥ </div>
                        <div class="sz1">{{ returnData.useWithdrawMoney.toString() }}</div>
                    </div>
                    <div class="flx at" style="padding-top: 10px;">
                        <div class="sz">可提现金额(元)</div>
                        <van-icon name="question-o" size="18px" style="margin-top: 3px;margin-left: 10px;" @click.stop="showtoast('可提现金额是当前处于可提现状态的收益金额，正常情况下均为正值，极端情况下如有购买产品用户在收益冻结期之后发生退款，会从可提取金额先进行扣除，此时有可能会出现可提现金额为负值的现象')" />
                    </div>
                </div>
            </div>
            <div class="line_">
                <div class="line"></div>
                <div class="linetext">提现金额</div>
            </div>
            <div>
                <van-field v-model="sms" type="number" center clearable label="¥" placeholder="请输入提现金额" label-width="30px" @input="input" size="large">
                    <template #button>
                        <van-button size="small" type="info" round color="#a4a3a3" @click.stop="sms=returnData.useWithdrawMoney" style="margin-left: 20px;">全部提现</van-button>
                    </template>
                </van-field>
            </div>
            <div class="stat">
                <div>总收益{{ returnData.shopMoney.toString() }}元，已提现金额{{ returnData.usedWithdrawMoney.toString() }}元</div>
                <div class="flx_">
                    <div>冻结金额 {{ returnData.lockMoney.toString() }}元 </div>
                    <van-icon name="question-o" size="18px" style="margin-left: 10px;"
                        @click.stop="showtoast('用户确定收货或者7天后，冻结金额会自动叠加到可提现金额')" />
                </div>
            </div>
            <van-notice-bar left-icon="info-o" scrollable :text="textmsg" />
            <div class="btn">
                <van-button type="primary" round size="small" style="width: 150px;"
                    @click.stop="show_Event">账户设置</van-button>
                <van-button type="info" round size="small" style="width: 150px;"
                    @click.stop="Withdrawal" color="rgb(102, 101, 245)">确定提现</van-button>
            </div>
           
            <div class="line_">
                <div class="line"></div>
                <div class="linetext">提现记录</div>
            </div>
            <div class="container">
                <div>
                    <div v-for="(items, index) in dataList" :key="index">
                        <div class="conflx" @click.stop="showdetilt(index)">
                            <van-icon name="gold-coin-o" color="rgb(243, 121, 7)" size="50px" style="padding: 5px;" />
                            <div style="padding: 5px;text-align: left;width: 65%;">
                                <div style="font-size:15px;">{{ items.content }}</div>
                                <div style="font-size:13px;margin-top: 5px;color: #b5b3b3;">{{ items.addTime }}</div>
                            </div>
                            <div>
                                <div style="font-size:20px;padding-bottom: 5px;">{{ items.amount.toFixed(2) }}</div>
                                <div
                                    :class="items.status == 0 ? 'status' : '' || items.status == 1 ? 'status_' : '' || items.status == 2 ? 'status_2' : ''">
                                    {{ items.status == 0 ? '审核中' : '' || items.status == 1 ? '已通过' : '' || items.status == 2 ? '已拒绝' : '' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="padding-top: 10px;padding-bottom: 20px;" v-if="total>10"> 
                 <van-pagination v-model="currentPage" :total-items="total" :items-per-page="per" @change="pagesChange" />
            </div>
            <!-- 调用组件 -->
            <div>
                <van-dialog v-model="show" title="账户设置" show-cancel-button :before-close="onBeforeClose"  @confirm="confirm" >
                    <van-form>
                        <van-field v-model="form.bankName" name="开户银行" label="开户银行" placeholder="开户银行"
                            :rules="[{ required: true, message: '请填写开户银行' }]" />
                        <van-field v-model="form.bankArea" name="开户网点" label="开户网点" placeholder="开户网点"
                            :rules="[{ required: true, message: '请填写开户网点' }]" />
                        <van-field v-model="form.bankUser" name="收款户名" label="收款户名" placeholder="收款户名"
                            :rules="[{ required: true, message: '请填写收款户名' }]" />
                        <van-field v-model="form.bankNo" name="收款帐户" label="收款帐户" placeholder="收款帐户"
                            :rules="[{ required: true, message: '请填写收款帐户' }]" />
                        <div style="margin: 20px;">
                            <!-- <van-button round block type="info" native-type="submit">提交</van-button> -->
                        </div>
                    </van-form>
                </van-dialog>
            </div>
            <!-- 调用组件 -->
            <div>
                <van-dialog v-model="showT" title="提现信息" show-cancel-button @confirm="confirmW">
                    <div style="padding: 50px;" v-if="msg.bankName==''">请先设置提现账户，点击 “账户设置”。</div>
                     <div v-else> 
                        <div class="line_">
                           <div class="line"></div>
                           <div class="linetext">账号信息</div>
                        </div>
                        <div class="msg0"> 
                            <div class="siz">开户银行:</div>
                            <div class="siz_">{{ msg.bankName }}</div>
                        </div>
                        <div class="msg0"> 
                            <div class="siz">开户网点:</div>
                            <div class="siz_">{{ msg.bankArea }}</div>
                        </div>
                        <div class="msg0"> 
                            <div class="siz">收款户名:</div>
                            <div class="siz_">{{ msg.bankUser }}</div>
                        </div>
                        <div class="msg0"> 
                            <div class="siz">收款帐户:</div>
                            <div class="siz_">{{ msg.bankNo }}</div>
                        </div>
                        <div class="line_">
                           <div class="line"></div>
                           <div class="linetext">提现金额</div>
                        </div>
                        <div class="msg0" style="padding-bottom: 10px;"> 
                            <div class="siz">申请提现金额:</div>
                            <div v-if="sms!=''" class="siz_" style="color: #000;font-weight: 600;font-size: 25px;">{{ sms }} 元</div>
                        </div>
                        <div class="msg0" style="padding-bottom: 30px;color: red;font-size: 14px;"> 
                            {{"手续费: "+discount+"%"}}
                        </div>
                     </div>
                </van-dialog>
            </div>
            <!-- 底部详情 -->
            <div> 
                <van-popup v-model="showbottom" position="bottom" :style="{ height: '75%' }">
                    <div class="bottomstyle"> 
                           <div class="flex_"> 
                               <div class="co">申请订单号: </div>
                               <div class="co1">{{ obj.outNo }}</div>
                           </div>
                           <div class="flex_"> 
                               <div class="co">申请状态: </div>
                               <div style="margin-left: 10px;" :class="obj.status == 0 ? 'status' : '' || obj.status == 1 ? 'status_' : '' || obj.status == 2 ? 'status_2' : ''">
                                    {{ obj.status == 0 ? '审核中' : '' || obj.status == 1 ? '已通过' : '' || obj.status == 2 ? '已拒绝' : '' }}</div>
                           </div>
                           <div class="flex_"> 
                               <div class="co">申请时间: </div>
                               <div class="co1">{{ obj.addTime }}</div>
                           </div>
                           <div class="flex_"> 
                               <div class="co">申请类别: </div>
                               <div class="co1">{{ obj.content }}</div>
                           </div>
                           <div class="flex_"> 
                               <div class="co">开户银行: </div>
                               <div class="co1">{{ obj.bankName }}</div>
                           </div>
                           <div class="flex_"> 
                               <div class="co">开户网点: </div>
                               <div class="co1">{{ obj.bankArea }}</div>
                           </div>
                           <div class="flex_"> 
                               <div class="co">收款户名: </div>
                               <div class="co1">{{ obj.bankUser }}</div>
                           </div>
                           <div class="flex_"> 
                               <div class="co">收款帐户: </div>
                               <div class="co1">{{ obj.bankNo }}</div>
                           </div>
                           <div class="flex_"> 
                               <div class="co">提现金额: </div>
                               <div class="co1">{{ obj.amount+' 元' }}</div>
                           </div>
                           <div class="flex_"> 
                               <div class="co">手续费率: </div>
                               <div class="co1">{{ obj.commissionRate+' %' }}</div>
                           </div>
                           <div class="flex_"> 
                               <div class="co">手续费: </div>
                               <div class="co1">{{ obj.commission+' 元' }}</div>
                           </div>
                           <div class="flex_"> 
                               <div class="co">实际到账金额: </div>
                               <div class="co1">{{ obj.actualMoney+' 元' }}</div>
                           </div>
                           <div class="flex_" v-if="obj.updateTime!=undefined"> 
                               <div class="co">受理时间: </div>
                               <div class="co1">{{ obj.updateTime}}</div>
                           </div>
                           <div class="flex_" v-if="obj.remark!=undefined"> 
                               <div class="co">备注: </div>
                               <div class="co1">{{ obj.remark}}</div>
                           </div>
                    </div>
                </van-popup>
            </div>
        </div>
    </div>
</template>

<script>
import request from '../api/request';
export default {
    data() {
        return {
            pageTitle: '提现', sms: '',  mo: '1.00', st: '0.00',canpr:4.09,
            dataList: [], isEmpty: false,
            show: false,showT:false,pr:1500,
            msg: { bankName: '', bankUser: '', bankArea: '', bankNo: '' },
            form:{bankName: '', bankUser: '', bankArea: '', bankNo: '' },
            returnData:{lockMoney:0,shopMoney:0,usedWithdrawMoney:0,useWithdrawMoney:0},
            minAmount:0,maxAmount:0,discount:1,textmsg:'',
            currentPage:1,total:0,per:10,showbottom:false,obj:{}
        }
    },
    mounted() {
       this.token=localStorage.getItem('token_yr')
       this.userinfo=JSON.parse(localStorage.getItem('usermsg'))
       this.getdata()
       
    },
    methods: {
        tofail() { },
        input(){
            var sms = '' + this.sms;
            sms = sms
        .replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
        .replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
        .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入两个小数
    if (sms.indexOf('.') < 0 && sms != '') {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        sms = parseFloat(sms);
    }
    this.sms = sms;
         },
         getlist(){
            const parms={shopId:this.id,page:this.currentPage}
            request.getcommerlist(parms,'/admin/withDraw/queryCashList','get',this.token,res=>{
                 console.log(res)
                 if(res.errno==0){
                    this.dataList=res.data.list
                    this.total=res.data.total
                 }
            })
         },
         pagesChange(e){
            this.currentPage=e
            this.getlist()
            console.log(e)
        },
         confirmW(){
            if(this.msg.bankName==''){
                return
            }else{
              const parms={shopId:this.id,amount:this.sms}
              request.postOther(parms,'/admin/withDraw/postWithdraw','post',this.token,res=>{
                 console.log(res)
                 if(res.errno==0){
                    // this.dataList.unshift(res.data)
                    // this.total=this.total+1
                    // this.returnData.usedWithdrawMoney=this.returnData.usedWithdrawMoney+this.sms
                    // this.returnData.useWithdrawMoney=this.returnData.useWithdrawMoney-this.sms
                    this.getdata()
                 }
                 this.$toast(res.errmsg)
            })
            }
         },
         Withdrawal(){
            //金额超出
            if(this.returnData.useWithdrawMoney<this.sms){
                this.showtoast('可提现金额不足!')
                return
            }else if(Number(this.sms)<this.minAmount){
                this.showtoast(`最低提现金额不能低于${this.minAmount}元!`)
                return
            }else if(Number(this.sms)>this.maxAmount){
                this.showtoast(`最高提现金额不能高于${this.maxAmount}元!`)
                return
            }else{
                this.showT=true
            }
            // 
         },
         showdetilt(e){
            console.log(this.dataList[e])
            this.obj=this.dataList[e]
            console.log(this.obj)
            this.showbottom=true
         },
        getdata(){
            console.log(this.userinfo.orgCode)
            console.log(this.token)
            request.getcommerlist({orgCode:this.userinfo.orgCode},'/admin/withDraw/withDrawDetail','get',this.token,res=>{
                 console.log(res)
                 if(res.errno==0){
                    this.returnData=res.data.info
                    this.getbankMsg(res.data.info.id)
                    this.id=res.data.info.id
                    this.discount=res.data.discount
                    this.maxAmount=res.data.maxAmount
                    this.minAmount=res.data.minAmount
                    this.textmsg="单笔提现限额额度为:"+res.data.minAmount+"~"+res.data.maxAmount+"元"
                    this.getlist()
                 }
            })
        },
        showtoast(data){
            this.$dialog.alert({
              message: data,
              })
        },
        onBeforeClose(action, done) {
     
         if (action === "confirm") {
             return done(false);
          } else {
            // 重置表单校验
            return done();
      }
    },
        show_Event(){
            this.form=JSON.parse(JSON.stringify(this.msg))
            console.log(this.form)
            this.show=true 
        },
        getbankMsg(id){
            const parms={shopId:id}
            request.getcommerlist(parms,'/admin/withDraw/getBankInfo','get',this.token,res=>{
                 console.log(res)
                 if(res.errno==0){
                    if(res.data!=undefined){
                        this.msg=res.data
                    }
                 }
            })
        },
        change(){
            console.log('sss')
        },
        confirm(){
                 if(this.form.bankName==''){
                    this.$toast('开户银行不能为空！')
                    if(this.show) return
                  }else if(this.form.bankArea==''){
                    this.$toast('开户网点不能为空！')
                    if(this.show) return
                  }else if(this.form.bankUser==''){
                    this.$toast('收款户名不能为空！')
                    if(this.show) return
                  }else if(this.form.bankNo==''){
                    this.$toast('收款账户不能为空！')
                    if(this.show) return
                  }else{
                    this.form.id=this.id
                    this.form.shopId=this.id
                    this.show=false
                    // return
                    request.getcommerlist(this.form,'/admin/withDraw/addOrUpdateBank','post',this.token,res=>{
                //  console.log(res)
                    this.$toast(res.errmsg)
                    if(res.errno==0) {this.msg=this.form;this.show=false}
                    })
                  }
                  
                  
        }
    }
}
</script>

<style scoped lang="less">
.container {
    background: #f6f5f5;
    height: 100%;
    width: 100%;
    overflow: scroll;

}

.herad {
    padding: 20px;
    background: rgb(102, 101, 245);
    border-radius: 10px;
}

.flx {
    display: flex;
    justify-content: center;
    color: #fff
}

.flx_ {
    display: flex;
    align-items: center;
    margin-top: 10px;
    // color: #a4a3a3;
}

.at {
    align-items: center;
}

.sz {
    font-size: 14px;
}

.sz1 {
    font-size: 30px
}

.line_ {
    padding: 10px;
    display: flex;
    align-items: center;
}

.line {
    width: 5px;
    height: 18px;
    background: rgb(102, 101, 245);
    border-radius: 5px;
}

.linetext {
    font-size: 16px;
    margin-left: 5px;
}

.stat {
    padding: 10px;
    font-size: 14px;
    color: #b3b0b0;
    text-align: left;
}

.conflx {
    display: flex;
    align-items: center;
    background: #fff;
    width: 98%;
    margin-left: 1%;
    border-radius: 5px;
    margin-bottom: 5px
}

.status {
    color: rgb(245, 169, 6);
    font-size: 14px;
    margin-top: 10rpx;
    font-weight: 600;
}

.status_ {
    color: #4caf50;
    font-size: 14px;
    margin-top: 10rpx;
    font-weight: 600;
}

.status_2 {
    color: #ee1111;
    font-size: 14px;
    margin-top: 10rpx;
    font-weight: 600;
    display: flex;
    align-items: center;
}

.btn {
    display: flex;
    justify-content: space-around;
    padding-top: 10px;
    padding-bottom: 10px;
}
.msg0{display: flex;align-items: center; width: 90%;margin-left: 5%;padding-bottom: 5px;}
.siz{font-size: 14px;font-weight: 500; color: #959393;}
.siz_{font-size:14px;margin-left: 10px;color: #959393;}
.bottomstyle{padding: 10px;}
.flex_{display: flex; align-items: center;padding-bottom: 10px;}
.co{color: #000; font-size: 16px; font-weight: 600;}
.co1{color: #717070;font-size: 16px;margin-left: 10px;}
</style>